module.exports = __webpack_public_path__ + "static/media/s13.1c2c83ad.jpg";